import { render, staticRenderFns } from "./HomeLight.vue?vue&type=template&id=85f586f2&scoped=true&"
import script from "./HomeLight.vue?vue&type=script&lang=js&"
export * from "./HomeLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f586f2",
  null
  
)

export default component.exports